import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
  message?: string;
}

export function LoadingSpinner({ size = 'md', fullScreen = false, message }: LoadingSpinnerProps) {
  return (
    <div className={`loading-spinner-container ${fullScreen ? 'loading-fullscreen' : ''}`}>
      <div className={`loading-spinner loading-spinner-${size}`} aria-label="Loading">
        <div className="spinner-ring" />
      </div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );
}
